// import yourEnhancers from '../path/to/yourEnhancer'
import { StoreEnhancer } from 'redux';

const enhancers: StoreEnhancer[] = [
  // yourEnhancer,
  // array of enhancers you want to apply
];

export default enhancers;
